import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectosDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectosService {
  public proyectoShared: ProyectosDTO | null = null;
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getProyectosService(): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL + '/api/v1/proyectos',
    );
  }

  guardarProyectosService(
    proyectosDTO: ProyectosDTO,
  ): Observable<BodyResponse<ProyectosDTO>> {
    return this.http.post<BodyResponse<ProyectosDTO>>(
      API_URL + '/api/v1/proyectos',
      proyectosDTO,
    );
  }

  getProyectosPorCodigoProyectoService(
    codigoProyecto: string,
  ): Observable<BodyResponse<ProyectosDTO>> {
    return this.http.get<BodyResponse<ProyectosDTO>>(
      API_URL + '/api/v1/proyectos/' + codigoProyecto,
    );
  }
  getProyectosPorNumeroIdentificacionEstudianteService(
    numeroIdentificacion: string,
  ): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL +
        '/api/v1/proyectos/numeroIdentificacion/estudiante/' +
        numeroIdentificacion,
    );
  }
  /*********nuevos */

  getProyectosPorNumeroIdentificacionService(
    numeroIdentificacion: string,
    estado: string,
  ): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL +
        '/api/v1/proyectos/numeroIdentificacion/' +
        numeroIdentificacion +
        '/' +
        estado,
    );
  }

  // obtener proyectos por tutor y por estado
  getProyectosPorNumeroIdentificacionTutoryEstadoProyectoService(
    numeroIdentificacion: string,
    estado: string,
  ): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL +
        '/api/v1/proyectos/numeroIdentificacion/tutor/estado/' +
        numeroIdentificacion +
        '/' +
        estado,
    );
  }

  getProyectosPorNumeroIdentificacionTutorService(
    numeroIdentificacion: string,
    numeroTutor: string,
    estado: string,
  ): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL +
        '/api/v1/proyectos/numeroIdentificacion/tutor/' +
        numeroIdentificacion +
        '/' +
        numeroTutor +
        '/' +
        estado,
    );
  }

  aprobarProyecto(
    proyectosDTO: ProyectosDTO,
  ): Observable<BodyResponse<ProyectosDTO>> {
    return this.http.post<BodyResponse<ProyectosDTO>>(
      API_URL + '/api/v1/proyectos/aprobarProyecto',
      proyectosDTO,
    );
  }

  obtenerProyectoPorEstadoProyectoService(
    estadoProyecto: string,
  ): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL + '/api/v1/proyectos/proyecto/estadoProyecto/' + estadoProyecto,
    );
  }
  /**************PROYECTOS SIN RELACIONAR****************/

  getProyectosConOpcionesProgramasService(
    opcion: string,
  ): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL + '/api/v1/proyectos/todos',
    );
  }
  // obtenerProyectosPorTipo
  getProyectosVinculacionPorNumeroIdentificacionTipoProyectoService(
    numeroIdentificacion: string,
    estado: string,
    tipoProyecto: string,
  ): Observable<BodyListResponse<ProyectosDTO>> {
    return this.http.get<BodyListResponse<ProyectosDTO>>(
      API_URL +
        '/api/v1/proyectos/numeroIdentificacion/tipoProyecto/' +
        numeroIdentificacion +
        '/' +
        estado +
        '/' +
        tipoProyecto,
    );
  }
}
